// assets/brand-logo-matcher.js
// Return only the logo of the matching brand

const SHOPIFY_API_VERSION = '2025-10';
const PAGE_SIZE = 100;

function tryParseJSON(value) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
}

// Normalize strings for comparison
function normalizeForMatch(str) {
  return String(str || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/[^\w\s]/g, '');
}

async function fetchBrandsPage(afterCursor = null) {
  const afterPart = afterCursor ? `, after: "${afterCursor}"` : '';
  const query = `
    query {
      metaobjects(type: "brand_name_and_logo", first: ${PAGE_SIZE}${afterPart}) {
        edges {
          cursor
          node {
            id
            handle
            fields {
              key
              value
              reference {
                __typename
                ... on MediaImage {
                  image {
                    url
                    altText
                  }
                }
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }`;

  const res = await fetch(`/api/${SHOPIFY_API_VERSION}/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.STOREFRONT_TOKEN || ''
    },
    body: JSON.stringify({ query })
  });

  const json = await res.json();
  if (json.errors) {
    console.error('GraphQL errors:', json.errors);
    throw new Error('GraphQL error');
  }
  return json.data.metaobjects;
}

async function loadAllBrands() {
  let all = [];
  let cursor = null;
  let hasNext = true;

  while (hasNext) {
    const page = await fetchBrandsPage(cursor);
    all = all.concat(page.edges.map(e => e.node));
    hasNext = page.pageInfo.hasNextPage;
    cursor = page.pageInfo.endCursor;
  }
  return all;
}

function extractNameAndLogo(fields) {
  let names = [];
  let logoUrl = '';

  for (const f of fields || []) {
    const key = (f.key || '').toLowerCase();
    const val = f.value || '';

    if (key.includes('name')) {
      const parsed = tryParseJSON(val);
      if (parsed) {
        if (Array.isArray(parsed)) {
          names = names.concat(parsed.map(n => String(n).trim()).filter(n => n));
        } else if (typeof parsed === 'object') {
          const text = parsed.text || parsed.name || JSON.stringify(parsed);
          names.push(String(text).trim());
        } else {
          names.push(String(parsed).trim());
        }
      } else {
        names.push(String(val).trim());
      }
    }

    if (key.includes('logo')) {
      if (f.reference && f.reference.__typename === 'MediaImage') {
        logoUrl = f.reference.image?.url || '';
      } else {
        const parsed = tryParseJSON(val);
        if (parsed) {
          if (Array.isArray(parsed)) {
            const first = parsed[0];
            if (typeof first === 'string' && first.startsWith('http')) logoUrl = first;
            else if (typeof first === 'object') logoUrl = first.src || first.url || first.preview || '';
          } else if (typeof parsed === 'object') {
            logoUrl = parsed.src || parsed.url || parsed.preview || parsed.path || '';
          } else if (typeof parsed === 'string' && parsed.startsWith('http')) {
            logoUrl = parsed;
          }
        } else {
          if (typeof val === 'string' && (val.includes('http://') || val.includes('https://'))) {
            const match = val.match(/https?:\/\/\S+/);
            if (match) logoUrl = match[0];
          } else {
            logoUrl = val;
          }
        }
      }
    }
  }

  return { 
    names: [...new Set(names)],
    logoUrl: logoUrl.trim() 
  };
}

async function getMatchingBrandLogo(vendor) {
  const vendorNormalized = normalizeForMatch(vendor);
  const brands = await loadAllBrands();

  for (const brand of brands) {
    const { names, logoUrl } = extractNameAndLogo(brand.fields || []);
    const matchedName = names.find(name => normalizeForMatch(name) === vendorNormalized);
    
    if (matchedName && logoUrl) {
      return {
        matched: true,
        brandName: matchedName,
        logoUrl: logoUrl
      };
    }
  }

  return {
    matched: false,
    brandName: null,
    logoUrl: null
  };
}

async function displayMatchingLogo() {
  try {
    const vendorEl = document.getElementById('productVendor');
    const vendor = vendorEl ? vendorEl.textContent.trim() : '';
    const container = document.getElementById('brandLogoContainer');

    if (!container) return;

    container.innerHTML = '<p>Finding matching logo…</p>';

    const result = await getMatchingBrandLogo(vendor);

    if (result.matched && result.logoUrl) {
      container.innerHTML = `
        <img src="${result.logoUrl}" 
             alt="${result.brandName}" 
             style="max-width: 100%; height: auto;" 
             onerror="this.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22100%22 height=%22100%22%3E%3Crect fill=%22%23ddd%22 width=%22100%22 height=%22100%22/%3E%3C/svg%3E'" />
      `;

       // Update the existing image in your swatch
  const brandImg = document.querySelector('.t4s-swatch__item-brand.brand-display img.brand-logo');
  if (brandImg) {
    brandImg.src = result.logoUrl;
    brandImg.alt = result.brandName;
  }
   // 👉 Show brand swatch option only if brand logo found
  const brandOption = document.querySelector('.t4s-swatch__option.is-t4s-name__brand');
  if (brandOption) brandOption.style.display = 'block';
    } else {
      container.innerHTML = '<p style="color:#999;">No matching brand logo found.</p>';
    }
  } catch (err) {
    console.error('Error:', err);
    const container = document.getElementById('brandLogoContainer');
    if (container) container.innerHTML = `<p style="color:red;">Error: ${err.message}</p>`;
  }
}

document.addEventListener('DOMContentLoaded', displayMatchingLogo);